import { render, staticRenderFns } from "./KnIncomeStatus.vue?vue&type=template&id=639b5b48"
import script from "./KnIncomeStatus.js?vue&type=script&lang=js&external"
export * from "./KnIncomeStatus.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports